/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { ApiResponse } from 'shared/interfaces/site';

export const getEntities = (
	params: any
): Promise<ApiResponse> => {
	return apiClient.get('/entities', {
		params: {
			pageSize: 100,
			query: params.queryParams,
			sort: 'name',
		},
	});
};

export const useEntities = (queryParams?: any) => {
	const { data, isFetching, isFetched } = useQuery({
		queryKey: ['entities', { queryParams: queryParams }],
		queryFn: () =>
			getEntities({ queryParams: queryParams }),
	});

	const updateList = (sites: any) =>
		sites.reduce((acc: any, currentItem: any) => {
			const modifiedItem = {
				...currentItem,
			};
			acc.push(modifiedItem);

			return acc;
		}, []);

	return {
		data: data ? updateList(data?.rows) : [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
	};
};
